import useLocalStorage from "./useLocalStorage";

export enum FeatureFlagsAvailable {
}

export default function useLocalStorageFlag(
  key: FeatureFlagsAvailable,
  defaultValue: boolean = false
): boolean {
  const [flag] = useLocalStorage(`@capitalise/flag/${key}`, defaultValue);

  return flag;
}
